import { createSelectionListViewComponent } from 'factories/SelectionListView'
import { getSessionItem, updateSessionItem } from 'helpers/sessionStorage'
import { getStorageKey } from '.'

export default createSelectionListViewComponent({
  pageTitleLanguageKey: 'select',
  getItemSize: () => 45,
  allowSearch: () => false,
  getValue: () => getSessionItem(getStorageKey(), {}).item?.recurOnWeeksOfMonth,
  getOnChange: (self) => (each) => {
    updateSessionItem(getStorageKey(), {}, (draft) => {
      const index = draft.item.recurOnWeeksOfMonth.findIndex((one) => one === each.id)

      if (index > -1) {
        draft.item.recurOnWeeksOfMonth.splice(index, 1)
      } else {
        draft.item.recurOnWeeksOfMonth.push(each.id)
      }
    })
  },
  allowMultiple: true,
  allowSelectAllWhenMultiple: false,
})()
